import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSun = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 179,
	height: 178,
	fill: "none",
	viewBox: "0 0 179 178",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 89,
		cy: 89,
		r: 89,
		fill: "#FFC14A"
	})
});
export default SvgSun;
